import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=e1ad7822&scoped=true&"
import script from "./NavigationItem.vue?vue&type=script&lang=ts&"
export * from "./NavigationItem.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationItem.vue?vue&type=style&index=0&id=e1ad7822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ad7822",
  null
  
)

export default component.exports